import { ContainerModule } from 'inversify';
import { SockJsAdapter, Connection } from '@dealroadshow/socket-frontend-sdk';
import Client from '@dealroadshow/socket-frontend-sdk';
import JsonRpcDispatcher from '@dealroadshow/json-rpc-dispatcher';
import SocketConnection from '@framework/di/Providers/Socket/Connection';
import AdapterFactory from '@framework/di/Providers/Rpc/AdapterFactory';
import DITypes from './types';
import { SocketAdapter } from '../SocketAdapter';
import { SocketDispatcherFactory } from '../SocketDispatcherFactory';
import { RpcDispatcherFactory } from '../RpcDispatcherFactory';
import SocketClient from '../SocketClient';

export const SocketModule = new ContainerModule(({ bind }) => {
  // Socket bindings
  bind<Connection>(DITypes.SocketConnection).to(SocketConnection).inSingletonScope();

  bind<SockJsAdapter>(DITypes.SocketAdapter).to(SocketAdapter).inSingletonScope();

  bind<SocketDispatcherFactory>(DITypes.SocketDispatcherFactory).to(SocketDispatcherFactory).inSingletonScope();

  bind<JsonRpcDispatcher>(DITypes.SocketDispatcher)
    .toDynamicValue(({ get }) => {
      const factory = get<SocketDispatcherFactory>(DITypes.SocketDispatcherFactory);
      const socketAdapter = get<SockJsAdapter>(DITypes.SocketAdapter);
      return factory.create(socketAdapter);
    })
    .inSingletonScope();

  bind<Client>(DITypes.SocketClient).to(SocketClient).inSingletonScope();

  // HTTP RPC bindings
  bind<AdapterFactory>(DITypes.AdapterFactory).to(AdapterFactory).inSingletonScope();

  bind<RpcDispatcherFactory>(DITypes.RpcDispatcherFactory).to(RpcDispatcherFactory).inSingletonScope();

  bind<JsonRpcDispatcher>(DITypes.JsonRpcDispatcher)
    .toDynamicValue(({ get }) => {
      const factory = get<RpcDispatcherFactory>(DITypes.RpcDispatcherFactory);
      return factory.create();
    })
    .inSingletonScope();
});
